import type { SVGProps } from 'react';
import { forwardRef, Ref } from 'react';

const SvgVentilatieventiel = (
  props: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 40 40"
    role="img"
    aria-hidden={true}
    ref={ref}
    {...props}
  >
    <path
      fill="#B3E9B1"
      d="M20 35c8.284 0 15-6.716 15-15S28.284 5 20 5 5 11.716 5 20s6.716 15 15 15"
    />
    <path
      fill="#60D15D"
      fillRule="evenodd"
      d="M20 10.5a9.5 9.5 0 1 0 0 19 9.5 9.5 0 0 0 0-19M8.5 20c0-6.351 5.149-11.5 11.5-11.5S31.5 13.649 31.5 20 26.351 31.5 20 31.5 8.5 26.351 8.5 20"
      clipRule="evenodd"
    />
    <path
      fill="#00215B"
      fillRule="evenodd"
      d="M30.1 30.1a15.02 15.02 0 0 0 4.4-10.61h1A16.02 16.02 0 0 1 19.49 35.5v-1a15.02 15.02 0 0 0 10.61-4.4"
      clipRule="evenodd"
    />
  </svg>
);

/* eslint-disable import/no-default-export */
const ForwardRef = forwardRef(SvgVentilatieventiel);

export default ForwardRef;
